import * as React from 'react';
import {calculateTextWidth} from '../helpers';
import {memoizeOne} from '../helpers';

export interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  font: string;
  value: string;
  setFont?: boolean;
}

const caretWidth = 1;

export class InputAutoWidth extends React.Component<Props> {
  readonly calculateTextWidth = memoizeOne(calculateTextWidth);

  render() {
    const props = this.props;
    let {font, style, ...rest} = props;

    let width = this.calculateTextWidth(props.value, font);
    width = width + caretWidth;

    style = Object.assign({}, style);
    style.width = `${width}px`;
    style.boxSizing = 'content-box';
    if (props.setFont === true)
      style.font = font;

    return <input type="text" {...rest} style={style}/>;
  }
}
